import { colors, fonts, textStyles } from '../../shared/styles';

export const styles = {
  wrapper:(isMobile, hasHeroImage = false) => ({
    display: 'grid',
    gridTemplateColumns: !isMobile ? '1fr 1140px 1fr' : '',
    gridTemplateRows: !isMobile ? 'repeat(5, 1fr)' : '',
    // height: !isMobile ? '80vh' : '211px',
    // maxHeight: !isMobile ? '625px' : '211px',
    width: '100%',
    marginTop: !isMobile ? '50px' : '45px',
    overflow: 'hidden',
    // height: hasHeroImage && '300px',
  }),
  heroImageBlured: (imgUrl, isMobile) => ({
    display: !isMobile ? 'block' : 'none',
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    gridColumn: '1 / 4',
    gridRow: '1 / 6',
    filter: 'blur(8px) brightness(110%) contrast(100%)'
  }),
  heroImage: (imgUrl, isMobile, hasHeroImage = false) => ({
    width: '100%',
    height: '0',
    paddingTop: hasHeroImage ? '56.25%' : '29.25%',
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: hasHeroImage ? 'contain' : 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    gridColumn: !isMobile ? '2 / 3' : '1 / 4',
    gridRow: '1 / 6',
    zIndex: 80,
  }),
  gradientOverlay: {
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundImage: 'linear-gradient(rgba(0,0,0, 0), rgba(0,0,0, 0.8))',
    pointerEvents: 'none',
    zIndex: 90,
    gridColumn: '1 / 4',
    gridRow: '1 / 6'
  },
  titleContainer: (isMobile) => ({
    zIndex: 100,
    bottom: 0,
    left: 0,
    width:'100%',
    paddingBottom: 15,
    gridColumn: !isMobile ? '2 / 3' : '1 / 3',
    gridRow: '5 / 6',
    alignSelf: 'end'
  }),
  logoContainer: {
    display: 'inline-block',
    marginRight: 20,
    verticalAlign: 'middle'
  },
  nameColumn: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },
  name: (isMobile) => ({
    marginTop: 0,
    marginBottom: 0,
    color: colors.white,
    fontFamily: fonts.heavy,
    fontSize: isMobile ? '30px' : '35px',
    letterSpacing: isMobile ? '0px' : '-0.22px',
    lineHeight: isMobile ? '32px' : '25px'
  }),
  info: {
    display: 'inline-block',
    verticalAlign:'bottom',
    width: '85%'
  },
  social: {
    display: 'inline-block',
    textAlign:'right',
    verticalAlign:'bottom',
    width: '15%'
  },
  hero: {
    position: 'relative',
    top: 0,
  },
  tabRow: {
    backgroundColor: colors.white,
    boxShadow: colors.cardShadow,
  },
  tabsContainer: () => ({
    whiteSpace: 'nowrap',
    overflowX: 'auto',
  }),
  tabItem: {
    display: 'inline-block',
    ...textStyles.sectionHead,
    marginRight: 40,
    padding: '20px 2px 12px',
    borderBottom: '3px solid transparent',
  },

  active: {
    color: colors.blue,
    borderBottom: '3px solid '+ colors.blue,
  },
  navRightSide: {
    paddingTop: 12,
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  mobileSocialPosition: (isLive) => ({
    position: 'absolute',
    top: isLive ? 91 : 'unset',
    right: 10,
    padding: '10px 10px',
  }),



  // TODO: Check if styles below are used
  container: {
    textAlign: 'center',
  },
  title: Object.assign({}, textStyles.raceTitleDarkDesktop, {
    color: colors.white,
    textShadow: '0px 0px 6px rgba(0, 0, 0, 0.8)',
    width: '100%'
  }),
  darkTitle: Object.assign({}, textStyles.raceTitleDarkDesktop, {
    width: '100%'
  }),
  logo: {
    minWidth: '70px',
    maxWidth: '80px',
    height: 'auto',
    objectFit: 'contain',
  },
  lightInfo: Object.assign({}, textStyles.subhead1Grey, {
    color: colors.white,
    marginBottom: '8px',
    textShadow: '0px 0px 6px rgba(0, 0, 0, 0.8)',
  }),
  darkInfo: Object.assign({}, textStyles.subhead1Grey, {
    marginbottom: '8px',
  }),
  addToWishList: {
    marginLeft: 20,
    textAlign: 'center',
    marginTop: -1,
    padding: 3,
    paddingTop: 4,
    fontFamily: 'ProximaNovaRegular',
    borderRadius: '2px',
    color: colors.black,
    fontSize: '9px',
    border: `1px solid ${colors.black}`,
    textTransform: 'uppercase'
  },
  mainTextStyle: (color) => ({
    fontSize: 16,
    color,
    fontFamily: 'ProximaNovaRegular'
  }),
  eventDetailsDate: {
    fontSize: '14px',
    color: colors.grey,
  },
  location: {
    fontSize: '12px',
    paddingLeft: 0,
    paddingRight: 0
  },
  register: {
    minWidth:120,
    marginBottom: 20,
    textTransform: 'uppercase',
    height: 42,
    fontFamily: 'ProximaNovaRegular',
    color:colors.white,
    fontSize: 18,
    borderRadius: 2,
    backgroundColor: colors.blue
  },
  eventDetailsCurr: {

  },
  loadMore: {
    textAlign: 'center',
    width: '100%',
    background: colors.blue,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: '0%',
    marginTop: 20
  },
  eventDetails: {
    marginBottom: 10
  },
  startDate: {
    paddingRight: 10,
    marginRight: 10,
    float: 'left',
    borderRight: `1px solid ${colors.lightGrey}`
  },
  socialShare: {
    float: 'right',
    paddingLeft: 6
  }
};
